var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "6" } },
            [
              _c("r-task-action", {
                attrs: { model: _vm.value.action },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "action", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "6" } },
            [
              _c("r-task-time-type", {
                attrs: { model: _vm.value.timeType },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "timeType", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.timeTypeCode === 0
        ? _c(
            "v-row",
            { staticClass: "mb-4", attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Duration (seconds):", "hide-details": "" },
                    model: {
                      value: _vm.value.duration,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "duration", _vm._n($$v))
                      },
                      expression: "value.duration",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  _c("r-ad-placement-dropdown", {
                    attrs: {
                      model: _vm.value.adPlacement,
                      title: "Ad Placement",
                      "hide-details": "",
                    },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.value, "adPlacement", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.timeTypeCode === 1
        ? _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  _c("v-text-field", {
                    attrs: { label: "Interval (seconds):", "hide-details": "" },
                    model: {
                      value: _vm.value.interval,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "interval", _vm._n($$v))
                      },
                      expression: "value.interval",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.timeTypeCode === 1
        ? _c(
            "v-row",
            { staticClass: "mb-4", attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Start Offest (seconds):",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.value.startOffset,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "startOffset", _vm._n($$v))
                      },
                      expression: "value.startOffset",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "End Offset (seconds):",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.value.endOffset,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "endOffset", _vm._n($$v))
                      },
                      expression: "value.endOffset",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-expansion-panels",
        [
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ open }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { "no-gutters": "" } },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-top": "5px" } },
                              [_vm._v("Prices")]
                            ),
                            _c("v-spacer"),
                            _c("v-fade-transition", [
                              open
                                ? _c(
                                    "span",
                                    { staticStyle: { display: "inline-flex" } },
                                    [
                                      _c("v-divider", {
                                        staticClass: "mx-1",
                                        attrs: { vertical: "" },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "v-expansion-panel-content",
                [
                  _c("v-divider"),
                  _c("r-currency-table", {
                    attrs: { items: _vm.value.price, title: "Price" },
                  }),
                  _c("v-divider", { staticClass: "mb-4" }),
                  _c("r-currency-table", {
                    attrs: { items: _vm.value.rush, title: "Rush" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("r-reward-panel", {
            attrs: { model: _vm.model.reward, title: "Rewards" },
            on: {
              "update:model": function ($event) {
                return _vm.$set(_vm.model, "reward", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }